<template>
  <div class="subpage-dashboards gmp-devices-page">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'SubpageDevices',
};
</script>
